/**
 * Feature guard
 * This guard protects the route so a user can access features disabled by the administrator.
 */
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService, UtilsService } from '../_services';
import { OrganisationsService } from '../_services/api/organisations.service';
import { OrganisationFeatures } from '../_enums/permission';
import { OrganisationPermissionsInterface } from '../_interfaces/permissions.interface';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class FeaturesGuard {
  protected organisationPermissons: OrganisationPermissionsInterface;
  protected readonly OrganisationFeatures = OrganisationFeatures;

  constructor(
    private authSvc: AuthenticationService,
    private router: Router,
    private organisationService: OrganisationsService,
    private utilsService: UtilsService
  ) {}

  /**
   * Guard the route so a user can't access features that are disabled by the admin
   * @param route
   * @param state
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const feature = route.data.feature as OrganisationFeatures;

    try {
      const response = await lastValueFrom(
        this.organisationService.getOrganisationPermissions(this.authSvc.user.organisation_id)
      );
      this.organisationPermissons = response.data;
    } catch (err) {
      this.router.navigate(['/slicks/feed']);
      return false;
    }

    if (
      !this.organisationPermissons ||
      !this.utilsService.checkOrganisationPermissions(this.organisationPermissons, feature)
    ) {
      this.router.navigate(['/slicks/feed']);
      return false;
    }
    return true;
  }
}
